import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export function setFundingSourcePlaidVerificationStatus(rel, plaidVerificationStatus) {
    return rel.fundingSource ? _object_spread_props(_object_spread({}, rel), {
        fundingSource: rel.fundingSource.setPlaidVerificationStatus(plaidVerificationStatus)
    }) : rel;
}
export function setTitle(rel, title) {
    return _object_spread_props(_object_spread({}, rel), {
        title
    });
}
